import { useCallback } from "react"
import { MemberActions } from "#/services/memberActionTracking/memberActions"
import { useIntakeTracker } from "../IntakeTrackingProvider"

export function usePreVisitTracking() {
  const track = useIntakeTracker()
  const trackSubmissionAttempt = useCallback(
    (submissionAttemptId: string) => {
      // The returned callback retains this provider's flow after navigation.
      track(MemberActions.PRE_VISIT_FORM_SUBMISSION_ATTEMPTED, { submissionAttemptId })
      return () => track(MemberActions.PRE_VISIT_FORM_SUBMISSION_SUCCEEDED, { submissionAttemptId })
    },
    [track]
  )
  return { track, trackSubmissionAttempt }
}
